import { DataFormats } from '@skylab-shared/constants';
import { TinKind } from '@skylab-shared/dataModel';
import { format } from 'fecha';

export class ContextKeys {
    public static product(productId: number): string {
        return `product-${productId}`;
    }

    public static productInventoryLevel(productId: number): string {
        return `product-inventory-level-${productId}`;
    }

    public static advanceSummary(advanceId: number): string {
        return `advance-summary-${advanceId}`;
    }

    public static documentLinks(documentId: number): string {
        return `document-links-${documentId}`;
    }

    public static document(documentId: number): string {
        return `document-${documentId}`;
    }

    public static dateIncludedInAccounting(date: Date): string {
        const formatedDate = format(date, DataFormats.date.webApi);
        return `date-included-in-accounting-${formatedDate}`;
    }

    public static client(clientId: number): string {
        return `client-${clientId}`;
    }

    public static tin(tin: string, tinKind: TinKind): string {
        return `tin-${tin}-${tinKind}`;
    }

    public static productName(symbol: string): string {
        return `product-name-${symbol}`;
    }

    public static productSymbol(symbol: string): string {
        return `product-symbol-${symbol}`;
    }

    public static clientName(name: string): string {
        return `client-name-${name}`;
    }

    public static isInvoiceToReceipt(sun: string): string {
        return `is-invoice-to-receipt-${sun}`;
    }

    public static isInvoiceToInventoryGoodsIssue(sun: string): string {
        return `is-invoice-to-inventory-goods-issue-${sun}`;
    }

    public static isInvoiceToInventoryGoodsReceipt(sun: string): string {
        return `is-invoice-to-inventory-goods-receipt-${sun}`;
    }

    public static relatedGoodsIssueDocumentToInvoice(sun: string): string {
        return `related-goods-issue-document-to-invoice-${sun}`;
    }

    public static relatedGoodsReceiptDocumentToInvoice(sun: string): string {
        return `related-goods-receipt-document-to-invoice-${sun}`;
    }

    public static vatRatesUsedInWstoDocument(sun: string): string {
        return `vat-rates-used-in-wsto-document-${sun}`;
    }

    public static get company(): string {
        return `company`;
    }

    public static get systemCurrency(): string {
        return `system-currency`;
    }

    public static numberingWithLinkedSalePattern(id: number): string {
        return `numbering-with-linked-sale-pattern-${id}`;
    }
}
